import $axios from "@/helpers/axios-helper";
import { service_names } from "@/constants/Services";
import { Ability } from "@casl/ability";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { getId } from "@/helpers/utils";

const state = () => ({
  info: null,
  abilities: new Ability([]),
  studentAssigned: []
});

const generateUserAbility = userInfo => {
  let cachedPermissions = {};

  return userInfo.roles
    .filter(role => role.isActive)
    .reduce((allPms, role) => {
      const roleName = role.name;
      const permissions = role?.permissions;

      if (roleName === Role.Admin || roleName === Role.Principal) {
        cachedPermissions["manage:all"] = true;
        return allPms.concat({ action: "manage", subject: "all" });
      }

      permissions.forEach(newPms => {
        if (!cachedPermissions[newPms.name]) {
          cachedPermissions[newPms.name] = true;
          const [subject, action] = newPms.name.split(":");
          allPms.push({
            action,
            subject
          });
        }
      });

      return allPms;
    }, []);
};

const setDefaultRole = roles => {
  const roleActive = localStorage.getItem("roleActive");
  const newRoles = roles
    .sort((prvRole, nxtRole) => prvRole.priority - nxtRole.priority)
    .map((role, idx) => ({
      isActive: idx === 0,
      ...role
    }));
  if (roleActive) {
    roles.forEach(role => {
      role.isActive = role.name === roleActive;
    });
    if (roles.some(role => role.isActive)) return roles;
    return newRoles;
  }
  return newRoles;
};

const saveRoleActiveToLocalS = roles => {
  const roleActive = roles.find(role => role.isActive).name;
  localStorage.setItem("roleActive", roleActive);
};

//set inpuuter or reviewer by role active
const setInpuuterOrReviewer = state => {
  const roleIdActive = state.info?.roles?.find(role => role.isActive)?.id;
  const inputterOrReviewList = state.info?.isInputterOrReview;
  state.info.inputterOrReviewDetail = inputterOrReviewList.find(item =>
    item.authorized_role_id.includes(roleIdActive)
  );
};
const getters = {
  timezone: state => state.info?.reference?.timezone,
  info: state => state.info,
  allRole: state => state.info?.roles,
  role: (state, getters) => [getters.allRole?.find(role => role.isActive).name],
  roleId: (state, getters) => [getters.allRole?.find(role => role.isActive).id],
  abilities: state => state.abilities
};

const actions = {
  async FetchUserInformation({ commit, getters, dispatch }) {
    try {
      const path = `${service_names.user}/who-am-i`;
      const res = await $axios.get(path);

      if (res) {
        commit("setUserInfo", res.data);
        const userRole = getters["role"];
        if (hasValidRole(userRole, Role.Family)) {
          const userId = getId(getters["info"]);
          await dispatch("switchAccountChild/setDefaultChildAccounts", userId, {
            root: true
          });
        }
        return true;
      }
    } catch (error) {
      throw error;
    }
  },

  SwitchRole({ commit }, role) {
    commit("switchRole", role);
  },

  ClearUserInfo({ commit }) {
    commit("clearUserInfo");
  },

  getStudentAssigned({ commit }) {
    $axios
      .get(`${service_names.user}/progress-setting/student-ids/current-user`)
      .then(response => {
        commit("setListStudentAssigned", response.data);
      });
  }
};

const mutations = {
  setUserInfo(state, userInfo) {
    let newInfo = { ...userInfo };
    newInfo.roles = setDefaultRole(newInfo.roles);
    saveRoleActiveToLocalS(newInfo.roles);
    const newAbilities = generateUserAbility(newInfo);
    state.info = { ...state.info, ...newInfo };
    state.abilities.update(newAbilities);
    setInpuuterOrReviewer(state);
  },
  switchRole(state, roleSelected) {
    state.info.roles.forEach(role => {
      if (role.name === roleSelected) {
        role.isActive = true;
        localStorage.setItem("roleActive", roleSelected);
      } else role.isActive = false;
    });
    const newAbilities = generateUserAbility(state.info);
    state.abilities.update(newAbilities);
    setInpuuterOrReviewer(state);
  },

  clearUserInfo(state) {
    localStorage.removeItem("roleActive");
    state.info = {};
    state.abilities.update([]);
  },

  setTimezone(state, timezone) {
    state.info.reference = { ...state.info.reference, timezone: timezone };
  },

  setListStudentAssigned(state, data) {
    state.studentAssigned = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
